import React, { useState, useEffect, useRef } from 'react';
import styles from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img';
import { useLang } from '@/i18n';
import { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useGsapReveal } from '../useHooks/useGsapReveal';

const CompactDesign = () => {
    const swiperRef = useRef<any>(null);
    const { t } = useLang('Delta3AirSeries.CompactDesign');

    useGsapReveal(
        {
            trigger: '.compact-design-pc',
            image: '.img-wrap',
            text: '.show-text',
        },
        [],
    );

    return (
        <section className={`${styles.CompactDesign} GtmModuleData-section range6`} id="D3A-CompactDesign" data-section-id={'D3A-CompactDesign'}>
            <div className="content">
                <div className="compact-design-pc">
                    <div className="left-box content-box">
                        <div className="top-text show-text">
                            <div className="title">{t('title')}</div>
                            <div className="desc">
                                {t.rich('desc', {
                                    text1: (str: string) => <span className="text1">{str}</span>,
                                })}
                            </div>
                        </div>
                        <div className="img-wrap">
                            <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1763468044111/compact-1.jpg" />
                        </div>
                    </div>
                    <div className="right-box content-box">
                        <div className="img-wrap">
                            <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1763468044849/compact-2.jpg" />
                        </div>
                        <div className="bottom-text show-text">
                            <div className="params-label">{t('label_1')}</div>
                            <span className="params-value">{t('value_1')}</span>
                        </div>
                    </div>
                </div>
                {/* pc和h5布局差距大，分开组件 */}
                <div className="compact-design-h5">
                    <div className="title">{t('title')}</div>
                    <div className="swiper-wrap">
                        <Swiper
                            modules={[Navigation, Pagination]}
                            pagination
                            slidesPerView={1}
                            className="compact-swiper"
                            onSwiper={(swiper) => {
                                swiperRef.current = swiper;
                            }}
                        >
                            <SwiperSlide className="item-card-slide">
                                <EcoImg
                                    pc="https://websiteoss.ecoflow.com/upload/image/1763468044111/compact-1.jpg"
                                    pad="https://websiteoss.ecoflow.com/upload/image/1763468043922/compact-1-m.jpg"
                                    h5="https://websiteoss.ecoflow.com/upload/image/1763468043922/compact-1-m.jpg"
                                ></EcoImg>
                            </SwiperSlide>
                            <SwiperSlide className="item-card-slide">
                                <EcoImg
                                    pc="https://websiteoss.ecoflow.com/upload/image/1763468044849/compact-2.jpg"
                                    pad="https://websiteoss.ecoflow.com/upload/image/1763468044510/compact-2-m.jpg"
                                    h5="https://websiteoss.ecoflow.com/upload/image/1763468044510/compact-2-m.jpg"
                                ></EcoImg>
                            </SwiperSlide>
                        </Swiper>
                    </div>
                    <div className="compact-params">
                        <div className="params-item">
                            <div className="params-label">{t('label_1')}</div>
                            <div className="params-value">{t('value_1')}</div>
                        </div>
                        {/* <span className="line"></span>
                        <div className="params-item">
                            <div className="params-label">Net Weight</div>
                            <div className="params-value">9.9kg</div>
                        </div> */}
                    </div>
                    <div className="compact-tips">
                        {t.rich('desc', {
                            text1: (str: string) => <span className="text1">{str}</span>,
                        })}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CompactDesign;
